'use client'

import type { StaticImageData } from 'next/image'
import { createPngDataUri } from 'unlazy/blurhash'
import { cn } from '@/utilities/cn'
import NextImage from '@/components/Image'
import React from 'react'
import type { MediaProps as MediaProps } from '../types'

export const ImageMedia: React.FC<MediaProps> = (props) => {
  const {
    alt: altFromProps,
    fill,
    imgClassName,
    priority,
    resource,
    size: sizeFromProps,
    src: srcFromProps,
    loading: loadingFromProps,
    style,
  } = props

  let width: number | undefined
  let height: number | undefined
  let alt = altFromProps
  let src: StaticImageData | string = srcFromProps || ''
  const blurhash =
    resource && typeof resource === 'object' && resource.blurhash
      ? createPngDataUri(resource.blurhash)
      : ''

  if (!src && resource && typeof resource === 'object') {
    const {
      alt: altFromResource,
      filename: fullFilename,
      height: fullHeight,
      url,
      width: fullWidth,
    } = resource

    width = fullWidth!
    height = fullHeight!
    alt = altFromResource || ''

    src = url ?? ''
    // src = `${getClientSideURL()}${url}`
  }

  // A priority image is loaded eagerly by Next; passing loading="lazy" alongside it is an error.
  const loading = priority ? undefined : loadingFromProps || 'lazy'
  // Without a known display size, the viewport width is the safe upper bound. (The old default,
  // `calc(<breakpoint>*2)`, asked for twice the screen width; the browser already scales for
  // pixel density itself.)
  const sizes = sizeFromProps || '100vw'
  return (
    <picture>
      <NextImage
        alt={alt || ''}
        className={cn(imgClassName)}
        fill={fill}
        placeholder="blur"
        blurDataURL={blurhash}
        priority={priority}
        fetchPriority={priority ? 'high' : undefined}
        loading={loading}
        sizes={sizes}
        src={src}
        width={!fill ? width : undefined}
        height={!fill ? height : undefined}
        style={style}
      />
    </picture>
  )
}
